module.exports = __webpack_public_path__ + "static/illustration2-ddff4585753567eb962044da5eb507c8.png";